import React, {useEffect, useState} from 'react';
import IndustryOutReachComponent from '../../../Components/UserComponents/IndustryOutreach';
import {getIndustryById} from '../../../Store/Actions/industry';
import {useDispatch, useSelector} from 'react-redux';

const IndustryOutReachContainer = () => {
  const dispatch = useDispatch();
  const [industryData, setIndustryData] = useState();
  const {allIndustries} = useSelector(({industry}) => industry);

  useEffect(() => {
    if (allIndustries) {
      setIndustryData(allIndustries?.data?.industry[0]);
    }
  }, [allIndustries]);

  useEffect(() => {
    fetchIndustryById();
  }, []);

  const fetchIndustryById = () => {
    dispatch(getIndustryById());
  };

  return (
    <div>
      <IndustryOutReachComponent industryData={industryData} />
    </div>
  );
};

export default IndustryOutReachContainer;
